<template>
    <div class="w3-margin">
        <h4 class="page-title">ADATAIM</h4>          

        <div class="w3-bar-block w3-center">            
            <div v-if="$store.getters.isLogin" class="flex-center-container">
                <div class="w3-center w3-margin w3-padding" style="max-width:400px">
                    <img class="w3-margin w3-circle" v-bind:src="$store.getters.userProfile.photoUrl" style="width:150px">
                    <div><strong>{{$store.getters.userProfile.name}}</strong></div>
                    <div class="w3-margin-bottom">{{$store.getters.userProfile.email}}</div>            
                </div>
            </div> 
        </div>       

        <div v-if="profile" class="w3-modal-content w3-card-2 ">
            <div class="w3-display-container">
                <div class="theme-1">
                    <h3 class="w3-padding">Személyes adatok</h3>
                </div>
                <div class="w3-padding">
                    <div class="w3-margin-bottom">
                        <label class="w3-text-blue">Azonosító 
                            <font-awesome-icon class="cursorpointer" v-on:click="copyUserId" icon="clipboard"></font-awesome-icon>                                
                        </label>                        
                        <input id="ggUserId" readonly v-bind:value="$store.getters.userProfile.uid" type="text" class="w3-input w3-border w3-grey" >                                                                         
                    </div>
                    <div class="w3-margin-bottom">
                        <label class="w3-text-blue">Név</label>
                        <input v-model="profile.name" type="text" class="w3-input w3-border w3-light-grey" >                                                                         
                    </div>
                    <div class="w3-margin-bottom">
                        <label class="w3-text-blue">Publikus név</label>
                        <input v-model="profile.publicName" type="text" class="w3-input w3-border w3-light-grey" >                                                                         
                    </div>
                    <div class="w3-margin-bottom">
                        <label class="w3-text-blue">Neme</label>
                        <select v-model="profile.gender" class="w3-input w3-border w3-light-grey" >
                            <option v-for="(item, index) in $appData.gender" :key="index" v-bind:value="item.sign">{{item.name}}</option>
                        </select>
                    </div> 
                    <div class="w3-margin-bottom">
                        <label class="w3-text-blue">Születési idő (csak az évszám)</label>
                        <input v-model="profile.yearOfBirth" type="number" class="w3-input w3-border w3-light-grey" >                         
                    </div>                   
                </div>
            </div>
            <div class="w3-container w3-light-grey w3-padding">
                <button class="w3-button w3-border w3-border-green w3-right w3-green w3-hover-white" v-on:click="saveProfile">Mentés</button>
            </div>
        </div> 
        <div v-if="this.$store.getters.userProfile.provider=='password'" class="w3-modal-content w3-card-2">
            <div class="w3-display-container">
                <div class="theme-1">
                    <h3 class="w3-padding">Jelszó módosítás</h3>
                </div>
                <div class="w3-padding">
                    <div class="w3-margin-bottom">
                        <label class="w3-text-blue">Új jelszó</label>
                        <input v-model="newPwd" type="password" class="w3-input w3-border w3-light-grey" >                                                                         
                    </div>
                    <div class="w3-margin-bottom">
                        <label class="w3-text-blue">Új jelszó újra</label>
                        <input v-model="newPwd2" type="password" class="w3-input w3-border w3-light-grey" >                                                                         
                    </div>
                </div>
            </div>
            <div class="w3-container w3-light-grey w3-padding">
                <button class="w3-button w3-border w3-border-green w3-right w3-green w3-hover-white" v-on:click="savePwd">Mentés</button>
            </div>
        </div> 
        <div class="w3-modal-content w3-card-2">  
            <div class="w3-display-container">
                <div class="theme-1">
                    <h3 class="w3-padding">Számlázási és cím adatok</h3>
                </div>
                <div class="w3-row">
                    <div class="w3-padding w3-large">Számlázási adatok</div>    
                    <div class="w3-half w3-mobile">          
                        <div class="w3-padding ">
                            <label class="w3-text-blue">Adószám (ha van): </label>
                            <input v-model="addressData.invVatNum" class="w3-input w3-border" >                         
                        </div>
                    </div>
                    <div class="w3-half w3-mobile">
                        <div class="w3-padding ">
                            <label class="w3-text-blue">Számlázási név:</label>
                            <input v-model="addressData.invName" class="w3-input w3-border">
                        </div>      
                    </div>
                </div>
                <div class="w3-row">
                    <div class="w3-half w3-mobile">
                        <div class="w3-padding">
                            <label class="w3-text-blue">Irányítószám:</label>
                            <input v-model="addressData.invCode" type="number" class="w3-input w3-border">
                        </div>                
                    </div>
                    <div class="w3-half w3-mobile">                                
                        <div class="w3-padding">
                            <label class="w3-text-blue">Település:</label>
                            <input v-model="addressData.invCity" class="w3-input w3-border" >                         
                        </div>
                    </div>
                </div>
                <div class="w3-padding">
                    <label class="w3-text-blue">Cím:</label>
                    <input v-model="addressData.invAddress" class="w3-input w3-border" >                         
                </div>
                <div class="w3-row">
                    <div class="w3-padding w3-large">Cím adatok</div>                        
                    <div class="w3-half w3-mobile">
                        <div class="w3-padding">
                            <br>
                            <label class="">A számlázási és a postázási adatok megegyeznek: </label>
                            <input v-on:click="setPostAddress()" v-model="addressData.isPostCheck" class="w3-check " type="checkbox">
                        </div>      
                    </div>
                    <div class="w3-half w3-mobile">
                        <div class="w3-padding">
                            <label class="w3-text-blue">Név:</label>
                            <input v-model="addressData.postName" class="w3-input w3-border">
                        </div>      
                    </div>
                </div>
                <div class="w3-row">
                    <div class="w3-half w3-mobile">
                        <div class="w3-padding">
                            <label class="w3-text-blue">Irányítószám:</label>
                            <input v-model="addressData.postCode" type="number" class="w3-input w3-border">
                        </div>                
                    </div>
                    <div class="w3-half w3-mobile">                                
                        <div class="w3-padding">
                            <label class="w3-text-blue">Település:</label>
                            <input v-model="addressData.postCity" class="w3-input w3-border" >                         
                        </div>
                    </div>
                </div>
                <div class="w3-padding">
                    <label class="w3-text-blue">Cím:</label>
                    <input v-model="addressData.postAddress" class="w3-input w3-border" >                         
                </div>
            </div> 
            <div class="w3-container w3-light-grey w3-padding">
                <button class="w3-button w3-border w3-border-green w3-right w3-green w3-hover-white" v-on:click="saveAddressData">Mentés</button>
            </div>                        
        </div>     
        <!--                   
        <div v-if="profile" class="w3-modal-content w3-card-2">
            <div class="w3-display-container">
                <div class="theme-1">
                    <h3 class="w3-padding">Hírlevél</h3>
                </div>
                <div class="w3-padding">
                    <div>Amennyiben szeretne, kérjük, iratkozzon fel hírlevelünkre!</div>
                    <div class="w3-margin-left w3-padding w3-justify cursorpointer"><input type="checkbox" v-model="profile.newsletter"> Hozzájárulok, hogy az inf.csavargo@gmail.com címről hírlevelet küldjenek számomra a CsavarGo aktuális információiról.</div>
                </div>
            </div>
            <div class="w3-container w3-light-grey w3-padding">
                <button class="w3-button w3-border w3-border-green w3-right w3-green w3-hover-white" v-on:click="saveOtherData">Mentés</button>
            </div>
        </div> 
        -->
    </div>
</template>

<script>
const fb = require('../firebase.js')
export default {
    name: 'Profile',
    data() {
        return {
            isShowUserId:false,
            profile:null,
            newPwd:null,
            newPwd2:null,
            addressData:{
                isPostCheck:false,
				postName:"",
				postCode:"",
				postCity:"",
				postAddress:"",
				invName:"",
				invCode:"",
				invCity:"",
				invAddress:"",
				invVatNum:"",
            },			
        }
    },     
    components: {
    },
    methods: {
        copyUserId(){
            var copyText = document.getElementById("ggUserId");
            copyText.select();
            copyText.setSelectionRange(0, 99999)
            document.execCommand("copy");            
            alert("Az azonosítót vágólapra helyezése megtörtént.");
        },
        setPostAddress(){
            if (!this.addressData.isPostCheck) {
                this.addressData.postName=this.addressData.invName;
                this.addressData.postCode=this.addressData.invCode;
                this.addressData.postCity=this.addressData.invCity;
                this.addressData.postAddress=this.addressData.invAddress;                
            }
        },        
        saveAddressData(){
            fb.UpdateUserAddress(this.addressData,this.$store.getters.userProfile.uid)
            .then(res=>{
                this.$store.getters.userProfile.address=this.addressData;
                this.$dialog.alert(this.$setDialogMsg('w3-green','Adatmentés','Sikeres mentés!'));
            })
            .catch(e=>{
                console.log(e);
                this.$dialog.alert(this.$setDialogMsg('w3-red','Adatmentés','Hiba történt a mentés során!'));
            });	        
        }, 
        saveOtherData(){
            fb.UpdateUserOther(this.profile.newsletter,this.$store.getters.userProfile.uid)
            .then(res=>{
                this.$store.getters.userProfile.newsletter=this.profile.newsletter;
                this.$dialog.alert(this.$setDialogMsg('w3-green','Adatmentés','Sikeres mentés!'));
            })
            .catch(e=>{
                console.log(e);
                this.$dialog.alert(this.$setDialogMsg('w3-red','Adatmentés','Hiba történt a mentés során!'));
            });	        
        },                
        saveProfile(){
            this.showChangeProfile=false;
            this.$showSpinner();
            var isChangeName=(this.profile.name!=this.$store.getters.userProfile.name);
            fb.updateProfile(this.profile,isChangeName).then(res=>{
                this.$hideSpinner();
                this.$store.commit('setUserProfile', this.profile);
                this.$dialog.alert(this.$setDialogMsg('w3-green','Adatmódosítás',"Sikeres adatmódosítás."));
            }).catch(e=>{                  
                this.$hideSpinner();                
                this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt az adatmódosítás során.'));
            }) 
        },
        changeProfile(){ 
            this.profile = Object.assign({}, this.$store.getters.userProfile);    
            this.showChangeProfile=true;
        },
        savePwd(){
            if (this.newPwd==this.newPwd2) {
                this.showChangePwd=false;
                this.$showSpinner();
                fb.updatePwd(this.newPwd).then(res=>{
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-green','Jelszómódosítás',"Sikeres jelszómódosítás."));
                }).catch(e=>{                  
                    console.log(e);                    
                    this.$hideSpinner();                
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a jelszómódosítás során.<br>'+e.toString()));
                }) 
            } else {
                this.$dialog.alert(this.$setDialogMsg('w3-yellow','Figyelmeztetés','A két jelszó mező nem egyezik'));
            }
        },
    },
    mounted(){
        this.profile = Object.assign({}, this.$store.getters.userProfile);   
        this.addressData = Object.assign({}, this.$store.getters.userProfile.address);            
    }       
}
</script>

